import React from "react";
import { useTranslation } from "react-i18next";
import "./index.less";

interface PaymentHistoryOverlayComponentProps {
  onClose: () => void;
}

const PaymentHistoryOverlayComponent: React.FC<PaymentHistoryOverlayComponentProps> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="payment-history-overlay" onClick={onClose}>
      <div className="payment-history-overlay-footer">
        <p className="payment-history-overlay-text">{t("click-here-to-access-invoice")}</p>
        <button className="payment-history-overlay-button" onClick={onClose}>
          {t("confirm-btn")}
        </button>
      </div>
    </div>
  );
};

export default PaymentHistoryOverlayComponent;
